/* eslint-disable no-console */
import type { MetricsAdapter } from '../Metrics';

enum EventMetricLevelEnum {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

const logMark = (
  {
    message,
    level,
  }: {
    message: string;
    level?: EventMetricLevelEnum;
  },

  options?: Record<string, unknown>
): void => {
  const msg = level ? `${level}: ${message}` : message;
  let detailMsg = '';

  const contextName = typeof options?.contextName === 'string' ? options.contextName : '';
  const description = typeof options?.description === 'string' ? options.description : '';

  if (contextName) detailMsg += contextName;
  if (description) {
    detailMsg += detailMsg ? ` - ${description}` : description;
  }

  if (detailMsg) {
    performance.mark(msg, { detail: detailMsg });
  } else {
    performance.mark(msg);
  }
};

/**
 * Metrics adapter to add performance timing marks to the browser's performance timeline.
 */
const performanceMarksAdapter = (): MetricsAdapter => {
  return {
    setUser: () => {},
    logDuration: (name, options = {}) => {
      let desc = options.description ? ` (${options.description})` : '';
      if (options.context) {
        desc += ` ${JSON.stringify(options.context)}`;
      }
      const mesg = `METRIC ${name}${desc}`;
      const start = `${mesg} - START`;
      const end = `${mesg} - END`;

      performance.mark(start);

      return () => {
        performance.mark(end);
        performance.measure(mesg, start, end);
      };
    },
    setViewName: () => {},
    logEvent: (data) => {
      const { name, ...context } = data;
      logMark({ message: name }, context);
    },
    logWarning: (warning, options = {}) => {
      logMark({ message: warning, level: EventMetricLevelEnum.WARNING }, options);
    },
    logError: (error, options = {}) => {
      logMark(
        { message: `${error.name} ${error.message}`, level: EventMetricLevelEnum.ERROR },
        options
      );
    },
  };
};

export const TESTING_INTERNAL = { logMark };
export default performanceMarksAdapter;
